import React from 'react';
import { X } from 'lucide-react';

import styles from './CallAnalyticsActiveFilterChip.module.scss';

export interface CallAnalyticsActiveFilterChipProps {
    label: string;
    onClear: () => void;
}

export const CallAnalyticsActiveFilterChip: React.FC<CallAnalyticsActiveFilterChipProps> = ({ label, onClear }) => (
    <div className={styles.wrapper} data-testid='call-analytics-active-filter-chip'>
        <button type='button' className={styles.chip} onClick={onClear} aria-label={`Clear filter: ${label}`}>
            <span>Filtered: {label}</span>
            <X size={14} aria-hidden='true' />
        </button>
    </div>
);
